import { render, staticRenderFns } from "./StatPrestataires.vue?vue&type=template&id=e13c5c28&"
import script from "./StatPrestataires.vue?vue&type=script&lang=js&"
export * from "./StatPrestataires.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports